import { z } from 'zod';
import { FlowBlockValueFieldSchemaV2, FlowBlockValueFieldSchemaVariant } from './fieldSchema.js';
import { FlowBlockValueTemplateHint, validateFlowBlockValueTemplate } from './template.js';
/**
 * @arg stringValidationSchema - User supplied zod string schema that is checked if value is not a block
 * value template. e.g. `z.string().maxLength(20)`
 * @returns A Zod schema for validating values that are either block value templates or some zod string type.
 */
export function FlowBlockValueStringSchema(args) {
    return z.coerce.string().superRefine((stringValue, context) => {
        const templateParseResult = FlowBlockValueFieldSchemaV2({
            variant: FlowBlockValueFieldSchemaVariant.TemplateOnly,
        }).safeParse(stringValue);
        if (templateParseResult.success) {
            return;
        }
        // We want to validate against string schema only if string is not template-like
        const templateValidation = validateFlowBlockValueTemplate(stringValue);
        if (templateValidation.hint !== FlowBlockValueTemplateHint.NotTemplateLike) {
            templateParseResult.error.issues.forEach((issue) => {
                context.addIssue(issue);
            });
            return;
        }
        const stringParseResult = args.stringValidationSchema.safeParse(stringValue);
        if (stringParseResult.success) {
            return;
        }
        stringParseResult.error.issues.forEach((issue) => {
            context.addIssue(issue);
        });
        templateParseResult.error.issues.forEach((issue) => {
            context.addIssue(issue);
        });
    });
}
//# sourceMappingURL=stringSchema.js.map